import axiosIns from "@/libs/axios";
export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    addNewReview(ctx, payload) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("saveResult", payload)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    fetchQuestionnaires(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("getQuestionnaires")
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    createReviewPdf(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("createReviewPdf", data, { responseType: "blob" })
          //.post('inventoryReport', data )
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    createNewFormPdf(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("createNewFormPdf", data, { responseType: "blob" })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    createEmptyFormPdf(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("createEmptyFormPdf", data, { responseType: "blob" })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    createReviewReportPdf(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("createReviewReportPdf", data, { responseType: "blob" })
          //.post('inventoryReport', data )
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    // New Tab-Specific Report Actions
    // Dashboard removed - Dashboard tab now uses Summary Report

    createSummaryReportPdf(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("createSummaryReportPdf", data, { responseType: "blob" })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    createManagerReportPdf(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("createManagerReportPdf", data, { responseType: "blob" })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    createStaffReportPdf(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("createStaffReportPdf", data, { responseType: "blob" })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    createManagerSummaryReportPdf(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("createManagerSummaryReportPdf", data, { responseType: "blob" })
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    getAllReviewResults(ctx, filterDate) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("listResult", filterDate)
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    deleteReview(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns
          .delete(`deleteResult/${id}`)
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    updateArchive(ctx, review) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`updateArchive/${review.id}`, review)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    timelineReviewList(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`timelineReviewList/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
    completeReview(ctx, review) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`completeReview/${review.id}`, review)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
    mailSend(ctx, data) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post("mailSend", data)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
    fetchReview(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`review/${id}`)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },
    editReview(ctx, review) {
      return new Promise((resolve, reject) => {
        axiosIns
          .put(`editResult/${review.id}`, review)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    getLastEventItem(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("getLastResult", {})
          .then((response) => {
            resolve(response);
          })

          .catch((error) => reject(error));
      });
    },

    getReviewsWithId(ctx, filter) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post(`getResultsWithEventId/${filter.event.id}`, filter)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    getResultsWithEventIdTable(ctx, filter) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post(`getResultsWithEventIdTable/${filter.event.id}`, filter)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => reject(error));
      });
    },

    // ── Follow-up actions ──────────────────────────────────────────────────────

    fetchPendingFollowups(ctx) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get("pendingFollowups")
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    fetchPendingFollowupsForResult(ctx, resultId) {
      return new Promise((resolve, reject) => {
        axiosIns
          .get(`pendingFollowups/${resultId}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    promoteFollowup(ctx, id) {
      return new Promise((resolve, reject) => {
        axiosIns
          .post(`promoteFollowup/${id}`)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    updateQuestionnaireFollowUpConfig(ctx, { id, followUpConfig }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .patch(`questionnaires/${id}`, { follow_up_config: followUpConfig })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },

    updateGroupFollowUpMonths(ctx, { groupId, months }) {
      return new Promise((resolve, reject) => {
        axiosIns
          .patch(`groups/${groupId}`, { follow_up_months: months })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
  },
};
